//imports
import {
    CHANGE_LIST_OPEN_MODAL,
    CHANGE_LIST_SEARCH_REQUEST,
    CHANGE_LIST_SEARCH_RESULT,
    CHANGE_LIST_SEARCH_SUBUSERS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    result: null,
    openModal: false,
    loading: false,
    entity: null,
    users: []
}

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CHANGE_LIST_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, entity: action.payload.data }

        case CHANGE_LIST_SEARCH_REQUEST:
            return { ...state, loading: true }

        case CHANGE_LIST_SEARCH_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CHANGE_LIST_SEARCH_SUBUSERS_RESULT:
            return { ...state, users: action.payload.data }

        case CLEAR_REDUX:
            return ["", "CHANGE_LIST_AUDIT_LOGS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};